/*
LIME LABS COMMERCE LAYER
Component: PDP Utility Contract
Project: La Troupe
Version: 6.4
Status: LLCL-QA

Responsibilities:
- Preserve the complete Care material system as visible context.
- Keep only B-18I-proven materials interactive/expandable.
- Convert non-applicable material rows to static, disabled rows with no care instructions exposed.
- Leave Size Guide content and product-specific size facts independent.

No catalog, product, variant, inventory, pricing or metafield mutation.
*/

(() => {
  'use strict';

  if (window.__LLCL_PDP_V64_UTILITY_CONTRACT__) return;
  window.__LLCL_PDP_V64_UTILITY_CONTRACT__ = true;

  const CARE_ROOT = '[data-ll-v63-care]';

  const disableInactiveCareItems = root => {
    if (!(root instanceof Element)) return;

    const items = Array.from(root.querySelectorAll('.ll-pdp-v63-care-item'));
    if (!items.length) return;

    items.forEach(item => {
      if (item.classList.contains('is-relevant')) {
        item.dataset.careApplicability = 'active';
        item.removeAttribute('aria-disabled');

        if (item.matches('details')) {
          item.open = false;
        }

        return;
      }

      if (!item.matches('details')) return;

      const summary = item.querySelector(':scope > summary');
      if (!summary) return;

      const title = summary.querySelector('.ll-pdp-v63-care-item__title');
      const icons = summary.querySelector('.ll-pdp-v63-care-item__icons');

      const shell = document.createElement('div');
      shell.className = 'll-pdp-v63-care-item is-disabled';
      shell.setAttribute('aria-disabled', 'true');
      shell.dataset.careApplicability = 'inactive';

      const row = document.createElement('div');
      row.className = 'll-pdp-v64-care-disabled-summary';

      if (title) row.append(title.cloneNode(true));
      if (icons) row.append(icons.cloneNode(true));

      shell.append(row);
      item.replaceWith(shell);
    });

    root.dataset.llV64CareApplicabilityReady = 'true';
  };

  const enhance = scope => {
    const roots = [];

    if (scope?.matches?.(CARE_ROOT)) roots.push(scope);
    scope?.querySelectorAll?.(CARE_ROOT).forEach(root => roots.push(root));

    roots.forEach(disableInactiveCareItems);
  };

  const boot = (scope = document) => {
    window.requestAnimationFrame(() => enhance(scope));
  };

  document.addEventListener('shopify:section:load', event => {
    boot(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  } else {
    boot(document);
  }
})();
